import React, { useEffect, useRef, useState } from 'react';
import { BeatLoader } from 'react-spinners';
import TypeWriter from '../RevealrSummary/TypeWriter';
import { FaExternalLinkAlt } from 'react-icons/fa';
import Icon from '../../assets/images/favicon.png';
import './style.scoped.scss';

const Messages = ({
  arrayToMap,
  displayName,
  onStartTyping,
  onFinishTyping,
}) => {
  const messagesWrapperRef = useRef(null);
  const [isTyping, setIsTyping] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const userSearch = localStorage.getItem('SearchQuery');

  useEffect(() => {
    if (userSearch) setSearchQuery(userSearch);

    if (userSearch === null || userSearch === '' || userSearch.length === 0) {
      const highlightedElements = document.querySelectorAll('.highlighted');

      highlightedElements.forEach((element) => {
        element.classList.remove('highlighted');
      });
    }
  }, [userSearch, arrayToMap]);

  const scrollToBottom = () => {
    if (messagesWrapperRef.current) {
      messagesWrapperRef.current.scrollTop =
        messagesWrapperRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [arrayToMap]);

  useEffect(() => {
    if (isTyping) {
      const scrollInterval = setInterval(() => {
        scrollToBottom();
      }, 100); // Adjust the interval as needed
      return () => clearInterval(scrollInterval);
    } else {
      setTimeout(() => {
        scrollToBottom();
      }, 200);
    }
  }, [isTyping]);

  const handleStartTyping = () => {
    onStartTyping();
    setIsTyping(true);
  };

  const handleTypewriterFinish = () => {
    setIsTyping(false);
    onFinishTyping();
    scrollToBottom();
  };

  const responseLinks = (item) => {
    const responseLinks = [];

    for (const key in item.response.source_documents) {
      if (item.response.source_documents.hasOwnProperty(key)) {
        const link = item.response.source_documents[key];
        responseLinks.push(
          <span
            key={key}
            id='messagesAI'
            className='queryMessagesWrapper__messages__user responseLinks'
          >
            <a href={link} target='_blank' rel='noreferrer'>
              {key}
            </a>
            <span className='ml-3'>
              <FaExternalLinkAlt />
            </span>
          </span>
        );
      }
    }

    return responseLinks;
  };

  const highlightText = (html, query) => {
    if (query === '') {
      // If the query is empty, return the original HTML content
      return html;
    }

    const regex = new RegExp(`(${query})`, 'gi');
    const parts = html.split(/(<[^>]*>)/); // Split HTML content into text and HTML parts

    for (let i = 0; i < parts.length; i++) {
      if (i % 2 === 0) {
        // Text parts
        parts[i] = parts[i].replace(
          regex,
          '<span class="highlighted">$1</span>'
        );
      }
    }

    return parts.join(''); // Combine text and HTML parts back together
  };

  return (
    <div id='messagesWrapper' ref={messagesWrapperRef}>
      {arrayToMap.map((item) => {
        return (
          <div key={item.id}>
            <div className='queryMessagesWrapper__messages'>
              <div
                className='queryMessagesWrapper__messages__user'
                dangerouslySetInnerHTML={{
                  __html: highlightText(item.message, searchQuery),
                }}
              />
              <div id='ai-icon'>{displayName}</div>
            </div>

            <div
              id='wrapperMessagesAI'
              className='queryMessagesWrapper__messages'
            >
              <div id='wrapperMessagesAI-top'>
                <div id='ai-icon'>
                  <img src={Icon} alt='icon' />
                </div>
              </div>
              <div id='wrapperMessagesAI-bottom'>
                <span
                  id='messagesAI'
                  className='queryMessagesWrapper__messages__user'
                >
                  {item.response ? (
                    item.userMessage ? (
                      <TypeWriter
                        isQuery={true}
                        text={
                          item.response.Response
                            ? item.response.Response
                            : item.response.response
                        }
                        delay={2}
                        onStartTyping={handleStartTyping}
                        onFinishTyping={handleTypewriterFinish}
                      />
                    ) : (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: highlightText(
                            item.response.Response
                              ? item.response.Response
                              : item.response.response,
                            searchQuery
                          ),
                        }}
                      ></div>
                    )
                  ) : (
                    <div id='loadingLoader'>
                      <BeatLoader />
                    </div>
                  )}
                </span>
                {!item.userMessage &&
                item.response &&
                item.response.source_documents ? (
                  <div id='responseSource'>
                    {responseLinks(item).slice(0, 5)}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Messages;
